// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"632ffac0","453":"a9e4ac3e","455":"c5c320c1","977":"65faeb4e"}[chunkId] + ".chunk.js";
};